import React, { useEffect, useMemo, useState } from "react";
import { observer } from "mobx-react-lite";
import { useStores } from "_common/hooks";

import { useNavigate, useSearchParams } from "react-router-dom";

import HeaderTop from "_common/component/Layout/Header/HeaderTop";

import CoinTrade from "./CoinTrade";
import StockTrade from "./StockTrade";

const TradePage = observer(() => {
  const {
    authStore: { games, user },
  } = useStores();

  const [params] = useSearchParams();
  const symbol = params?.get("symbol") || "btcusdt";
  const time = params?.get("time") || "1m";
  const theme = params?.get("theme") || "dark";
  const type = params?.get("type") || "coin";

  return (
    <>
      <HeaderTop title="Giao dịch nhanh" />
      {type === "coin" && (
        <CoinTrade symbol={symbol} time={time} theme={theme} type={type} />
      )}
      {type === "forex" && (
        <CoinTrade symbol={symbol} time={time} theme={theme} type={type} />
      )}
      {type === "stock" && (
        <StockTrade symbol={symbol} time={time} theme={theme} type={type} />
      )}
    </>
  );
});

export default TradePage;
